import React from 'react';

const KEY_TIMES = '0; 0.766667; 0.8; 0.833333; 0.866667; 0.9; 0.933333; 0.966667; 1';
const KEY_SPLINES =
    '0 0 1 1; 0.55 0.06 0.36 1; 0.65 0 0.36 1; 0.65 0 0.36 1; 0.65 0 0.36 1; 0.65 0 0.36 1; 0.65 0 0.36 1; 0.65 0 0.36 1';

export const IconBellAnimated = () => (
    <svg
        className="icon-bell-animated"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
    >
        <g transform="translate(12,17)">
            <animateTransform
                attributeName="transform"
                type="translate"
                dur="5s"
                begin="0s"
                repeatCount="indefinite"
                calcMode="spline"
                values="12 17; 12 17; 13 17; 10 17; 14 17; 10 17; 14 17; 11 17; 12 17"
                keyTimes={KEY_TIMES}
                keySplines={KEY_SPLINES}
                fill="freeze"
            />
            <g transform="rotate(0)">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="5s"
                    begin="0s"
                    repeatCount="indefinite"
                    calcMode="spline"
                    values="0; 0; -2; 2; -4; 3; -3; 1; 0"
                    keyTimes={KEY_TIMES}
                    keySplines={KEY_SPLINES}
                    fill="freeze"
                />
                <g transform="translate(-4,0)">
                    <path
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinejoin="round"
                        d="M1,1C1.928,1.078,2.928,1.123,4,1.123C5.072,1.123,6.072,1.078,7,1C7,1,7,1.123,7,1.123C7,2.78,5.657,4.123,4,4.123C2.343,4.123,1,2.78,1,1.123C1,1.123,1,1,1,1C1,1,1,1,1,1Z"
                    />
                </g>
            </g>
        </g>
        <g transform="translate(12,2)">
            <g transform="rotate(0)">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="5s"
                    begin="0s"
                    repeatCount="indefinite"
                    calcMode="spline"
                    values="0; 0; 5; -5; 4; -4; 3; -3; 0"
                    keyTimes={KEY_TIMES}
                    keySplines={KEY_SPLINES}
                    fill="freeze"
                />
                <g transform="translate(-9,0)">
                    <path
                        fill="currentColor"
                        d="M3,7C3,7,4,7,4,7C4,4.239,6.239,2,9,2C9,2,9,1,9,1C9,1,9,0,9,0C5.134,0,2,3.134,2,7C2,7,3,7,3,7C3,7,3,7,3,7ZM9,1C9,1,9,2,9,2C11.761,2,14,4.239,14,7C14,7,15,7,15,7C15,7,16,7,16,7C16,3.134,12.866,0,9,0C9,0,9,1,9,1C9,1,9,1,9,1ZM12,15.877C12,15.877,11.917,14.881,11.917,14.881C11.016,14.956,10.044,15,9,15C9,15,9,16,9,16C9,16,9,17,9,17C10.1,17,11.127,16.954,12.083,16.874C12.083,16.874,12,15.877,12,15.877C12,15.877,12,15.877,12,15.877ZM17,15.038C17,15.038,16.745,14.071,16.745,14.071C15.466,14.409,13.857,14.718,11.917,14.881C11.917,14.881,12,15.877,12,15.877C12,15.877,12.083,16.874,12.083,16.874C14.143,16.702,15.867,16.372,17.255,16.005C17.255,16.005,17,15.038,17,15.038C17,15.038,17,15.038,17,15.038ZM6,15.877C6,15.877,6.083,14.881,6.083,14.881C4.143,14.718,2.534,14.409,1.255,14.071C1.255,14.071,1,15.038,1,15.038C1,15.038,0.745,16.005,0.745,16.005C2.133,16.372,3.857,16.702,5.917,16.874C5.917,16.874,6,15.877,6,15.877C6,15.877,6,15.877,6,15.877ZM9,16C9,16,9,15,9,15C7.956,15,6.984,14.956,6.083,14.881C6.083,14.881,6,15.877,6,15.877C6,15.877,5.917,16.874,5.917,16.874C6.873,16.954,7.9,17,9,17C9,17,9,16,9,16C9,16,9,16,9,16ZM17,15.038C17,15.038,18,15.038,18,15.038C18,14.584,17.823,13.811,17.486,12.997C17.137,12.153,16.572,11.158,15.707,10.293C15.707,10.293,15,11,15,11C15,11,14.293,11.707,14.293,11.707C14.928,12.342,15.363,13.097,15.639,13.762C15.776,14.093,15.869,14.392,15.927,14.629C15.956,14.747,15.975,14.847,15.987,14.922C15.999,15.003,16,15.039,16,15.038C16,15.038,17,15.038,17,15.038C17,15.038,17,15.038,17,15.038ZM15,7C15,7,14,7,14,7C14,7,14,11,14,11C14,11,15,11,15,11C15,11,16,11,16,11C16,11,16,7,16,7C16,7,15,7,15,7C15,7,15,7,15,7ZM3,11C3,11,4,11,4,11C4,11,4,7,4,7C4,7,3,7,3,7C3,7,2,7,2,7C2,7,2,11,2,11C2,11,3,11,3,11C3,11,3,11,3,11ZM1,15.038C1,15.038,2,15.038,2,15.038C2,15.039,2.001,15.003,2.013,14.922C2.024,14.847,2.044,14.747,2.073,14.629C2.131,14.392,2.224,14.093,2.361,13.762C2.637,13.097,3.072,12.342,3.707,11.707C3.707,11.707,3,11,3,11C3,11,2.293,10.293,2.293,10.293C1.428,11.158,0.863,12.153,0.514,12.997C0.177,13.811,0,14.584,0,15.038C0,15.038,1,15.038,1,15.038C1,15.038,1,15.038,1,15.038ZM12,15.877C12,15.877,11.917,14.881,11.917,14.881C11.917,14.881,12,15.877,12,15.877C12,15.877,12,15.877,12,15.877ZM6,15.877C6,15.877,5.917,16.874,5.917,16.874C5.917,16.874,6,15.877,6,15.877C6,15.877,6,15.877,6,15.877ZM17,15.038C17,15.038,17.255,16.005,17.255,16.005C17.694,15.889,18,15.492,18,15.038C18,15.038,17,15.038,17,15.038C17,15.038,17,15.038,17,15.038ZM15,11C15,11,14,11,14,11C14,11,14,11.414,14,11.414C14,11.414,14.293,11.707,14.293,11.707C14.293,11.707,15,11,15,11C15,11,15,11,15,11ZM3,11C3,11,3.707,11.707,3.707,11.707C3.707,11.707,4,11.414,4,11.414C4,11.414,4,11,4,11C4,11,3,11,3,11C3,11,3,11,3,11ZM1,15.038C1,15.038,0,15.038,0,15.038C0,15.492,0.306,15.889,0.745,16.005C0.745,16.005,1,15.038,1,15.038C1,15.038,1,15.038,1,15.038Z"
                    />
                </g>
            </g>
        </g>
    </svg>
);
